export enum LoadingConstraintEnum {
  NONE = 'no',
  DOCK = 'dock',
  HAYON = 'hayon',
  SIDE = 'side',
  TOP = 'top',
  CRANE = 'crane',
  MOUTED_FORKLIFT = 'mounted_forklift',
  RAMP = 'ramp',
}
